import React from 'react';
import { ModalController } from '../Modal/ControlledModal';
import GlobalProps from '../globalProps';
import { useChanges, Form } from '../Form/Form';
import { t } from '../../locales/translate';
import { TextField } from '../Form/TextField/TextField';
import { Activity, updateActivity } from '../../model/activity';
import { handleError } from '../../model/notification';

interface Props extends GlobalProps {
  controller: ModalController<Partial<Activity>>;
  onChange?: () => void;
}

export function CommentForm({ controller, onChange }: Props): JSX.Element {
  const [, , model, trackChanges] = useChanges<Partial<Activity>>(controller.model);

  async function handleOnSubmit(): Promise<void> {
    if (model.id) {
      try {
        await updateActivity({
          activityId: model.id,
          content: model.content,
        });
        if (onChange) {
          onChange();
        }
        controller.close();
      } catch (error) {
        handleError(error);
      }
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return <TextField name="content" label={t.actions.edit(t.model.activity.comment)} displayOptional={false} />;
      }}
    </Form>
  );
}
